var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoBoxArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 200,
    viewBox: "0 0 270 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.161 320.956L178.003 113.554L120.49 158.745L24.2372 35.2453",
    stroke: "white",
    strokeWidth: 50
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1685 21.4731L21.1704 20.9332L20.5361 107.864",
    stroke: "white",
    strokeWidth: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBoxArrow);
export default __webpack_public_path__ + "static/media/VideoBoxArrow.c3a99a543574e345f2aab6dd4f634f34.svg";
export { ForwardRef as ReactComponent };